import { TabView, TabPanel } from "primereact/tabview";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";
import { SubmissionHistoryList } from "./SubmissionHistoryList";
import { SubmissionHistoryDetail } from "./SubmissionHistoryDetail";
import { JobsInQueue } from "./JobsInQueue";
import { Enrichment } from "./Enrichment";
import { useLocalUser } from "../../data";

const SubmissionHistoryTabs = () => {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();
  // Bulk enrichment is an internal-only tool; the endpoint is admin-scoped, so
  // only surface its tab to admins (dropping it also keeps the tab-index → route
  // mapping correct for non-admins).
  const isAdmin = useLocalUser()?.scopes.includes("admin") ?? false;
  const tabs = isAdmin
    ? ["activity", "queue", "enrichment"]
    : ["activity", "queue"];
  const activeIndex = Math.max(0, tabs.indexOf(tab ?? ""));

  return (
    <TabView
      activeIndex={activeIndex}
      onTabChange={(e) => navigate(`../${tabs[e.index]}`, { replace: true })}
    >
      <TabPanel header="Activity Log">
        <SubmissionHistoryList />
      </TabPanel>
      <TabPanel header="Jobs in Queue">
        <JobsInQueue />
      </TabPanel>
      {isAdmin && (
        <TabPanel header="Enrichment">
          <Enrichment />
        </TabPanel>
      )}
    </TabView>
  );
};

export const SubmissionHistory = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="activity" replace />} />
      <Route path=":tab" element={<SubmissionHistoryTabs />} />
      <Route path="detail/:reportId" element={<SubmissionHistoryDetail />} />
    </Routes>
  );
};
